import type { RorProductSummary } from '../../../types/ror-product-summary'
import { buildRorProductSummary } from '../../../types/ror-product-summary'

const normalizeRorProductSummary = function (input: Object): RorProductSummary {
  return {
    ...buildRorProductSummary(input.productName),
    discountDayNames: input.discountDays,
    dateEffective: input.dateEffective === null ? null : new Date(input.dateEffective),
    endDate: input.endDate === null ? null : new Date(input.endDate),
    entryStationName: input.entryStationName,
    exitStationName: input.exitStationName,
    regionNames: input.regionNames,
    price: input.price
  }
}

export {
  normalizeRorProductSummary
}



// WEBPACK FOOTER //
// ./src/services/b2b/normalizer/RorProductSummaryNormalizer.js